import { L } from '@lib';
import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

const { Option } = Select;

interface IProps {
  onChange?: ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const PaidSelect: React.FC<IProps> = memo(({ onChange }) => {
  return (
    <Select style={{ width: 100 }} defaultValue="All" onChange={onChange}>
      <Option value={undefined}>{L('All')}</Option>
      <Option value={0}>{L('No')}</Option>
      <Option value={1}>{L('Yes')}</Option>
    </Select>
  );
});
